const Constants = {
    TYPE_VEHICLE_REQUEST_RENTAL: 'rent',
    CONFIG_MINUTE_STEP_DATE_TIME: 'minute_step',
    CONFIG_VALUE_MINUTE_STEP_DATE_TIME_DEFAULT: 60,
    CONFIG_VALUE_MINUTE_MIN_CHECKIN: 10,
    CONFIG_VALUE_MINUTE_MAX_CHECKIN: 15,
    CONFIG_KEY_TYPE_VEHICLE_REQUEST:'vehicle_request_type',
    CONFIG_KEY_VALUE_HOUR_VEHICLE_REQUEST:'hour_value',
    CONFIG_KEY_GOOGLE_MAPS:'key_api_google_maps',
    CONFIG_VALUE_VALUE_HOUR_VEHICLE_REQUEST_DEFAULT:'2',
    CONFIG_KEY_TERM_OF_USE_CLIENT: 'term_of_use',
    CONFIG_VALUE_TERM_OF_USE_CLIENT_PRECON: 'precon',
    CONFIG_VALUE_TERM_OF_USE_CLIENT_SEPLAG: 'seplag',
    CONFIG_VALUE_TERM_OF_USE_URL: 'file_term_of_use',
    CONFIG_VALUE_PAYMENT_ON_REQUEST: 'payment_on_request',
    CONFIG_MINUTE_STEP_DATE_TIME_DEFAULT: 60,


    PROFILE_MANAGER: 'manager',
    PROFILE_USER: 'user',
    PROFILE_ADMINISTRATOR: 'adm',
    PROFILE_DRIVER: 'driver',

    STEP_CODE_APPROVAL: 'approval',
    STEP_CODE_DEFINE_DRIVER: 'define-driver',
    STEP_CODE_CHECKIN: 'check-in',
    STEP_CODE_CHECKOUT: 'check-out',
    STEP_CODE_CANCEL: 'cancel',
    STEP_CODE_COMPLETE: 'complete',

    URL_BUCKET_PICKNDRIVE: 'https://pickndrive.s3.amazonaws.com/',

    FUNCIONALITY_OCR: 'ocr',

    CONTROL_FORM_FIELD_IMAGE: 'image',
    CONTROL_FORM_FIELD_IMAGE_HODOMETER: 'image_hodometer',
    CONTROL_FORM_FIELD_IMAGE_PARAMETER_CROP: 'crop',
};

export default Constants